import React from "react";

export const Theme = () => {
  return <div>Theme</div>;
};
